import { graphql } from '@/gql';
import type { MarketingAnalyticsPhoneNumbersQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchMarketingAnalyticsPhoneNumbers = async ({
  phoneNumber,
  isActive,
  pagination,
}: MarketingAnalyticsPhoneNumbersQueryVariables) => {
  const response = await queryExecute({
    query: graphql(`
      query MarketingAnalyticsPhoneNumbers($phoneNumber: String, $isActive: Boolean, $pagination: PaginationInputType) {
        marketingAnalyticsPhoneNumbers(phoneNumber: $phoneNumber, isActive: $isActive, pagination: $pagination) {
          count
          rows {
            phoneNumber
            description
            media
            platform
            existingCampaign
            notExistingCampaign
            regSource
            isActive
          }
        }
      }
    `),
    variables: {
      phoneNumber,
      isActive,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.marketingAnalyticsPhoneNumbers;
};
